module.exports = __webpack_public_path__ + "img/sm-164879726489234910.9feeaf5d.jpg";